import React, { Component } from "react";
import axios from "axios";

import {
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TablePagination
} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { NavLink } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import Serverurl from "./Apiurl";

class VendorProjectPendingPaymentReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId: "",
      vendorId: "",
openExportDialog: false,
      projectarrauto: [],
      vendorarrauto: [],

      selectedProject: null,
      selectedVendor: null,

      reportData: [],

      page: 0,
      rowsPerPage: 50,
      totalRecords: 0,

      loading: false
    };
  }

  componentDidMount() {
	  
	     document.title = "VR Builders - Project Ledger Report";
        
   	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Pending Payments";   
			 this.props.parentsCallback(
           strname
        );
    this.fetchReport();
  }

  /* REPORT  */

  fetchReport = () => {
    this.setState({ loading: true });

    axios
      .get(Serverurl + "ajaxprojects.php", {
        params: {
          action: "pendingpaymentgetall",
          projectid: this.state.projectId,
          vendorid: this.state.vendorId,
          StartIndex: this.state.page,
          PageSize: this.state.rowsPerPage,
          sorting: "ProjectId DESC"
        }
      })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];

        this.setState({
          reportData: data,
          totalRecords: data?.[0]?.count || 0,
          loading: false
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  /*  PAGINATION  */

  handlePageChange = (event, newPage) => {
    this.setState({ page: newPage }, () => this.fetchReport());
  };

  handleRowsChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      () => this.fetchReport()
    );
  };

  /* PROJECT */

  onloadProjectBind = (event) => {
    axios
      .get(Serverurl + "ajaxprojects.php", {
        params: {
          action: "getallprojectautoextender",
          projectname: event.target.value
        }
      })
      .then((res) => {
        const list = (res.data || []).map((x) => ({
          title: x.pj_projectname,
          pj_id: x.pj_id
        }));

        this.setState({ projectarrauto: list });
      });
  };

  onProjectChange = (event, value) => {
    this.setState({
      selectedProject: value,
      projectId: value ? value.pj_id : "",
      page: 0
    });
  };

  /*  VENDOR  */

  onloadVendorBind = (event) => {
    axios
      .get(Serverurl + "ajaxvendor.php", {
        params: {
          action: "getallautoextender",
          vendorname: event.target.value
        }
      })
      .then((res) => {
        const list = (res.data || []).map((x) => ({
          title: x.vm_vendorname,
          vm_id: x.vm_id
        }));

        this.setState({ vendorarrauto: list });
      });
  };

  onVendorChange = (event, value) => {
    this.setState({
      selectedVendor: value,
      vendorId: value ? value.vm_id : "",
      page: 0
    });
  };
exportExcel = () => {
  const { reportData } = this.state;

  if (!reportData.length) return alert("No data to export");

  const excelData = reportData.map((r) => ({
    Project: r.Project,
    Vendor: r.Vendor,
    Amount: r.Amount,
    Paid: r.Paid,
    Due: r.Due
  }));

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Pending Payments");

  const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  saveAs(new Blob([buffer]), "Pending_Payment_Report.xlsx");

  this.setState({ openExportDialog: false });
};
downloadPDF = () => {
  const { reportData } = this.state;

  const doc = new jsPDF("l", "mm", "a4");

  doc.setFontSize(14);
  doc.text("Pending Payment Report", 14, 15);

  const headers = [["Project", "Vendor", "Amount", "Paid", "Due"]];

  const rows = reportData.map((r) => [
    r.Project,
    r.Vendor,
    r.Amount,
    r.Paid,
    r.Due
  ]);

  autoTable(doc, {
    head: headers,
    body: rows,
    startY: 25
  });

  doc.save("Pending_Payment_Report.pdf");

  this.setState({ openExportDialog: false });
};
  /*  RENDER  */

  render() {
    const reportData = Array.isArray(this.state.reportData)
      ? this.state.reportData
      : [];

    return (
   
     

        
 <React.Fragment>
              
                   
                       

                         <div className="searchmaster">
                            <ul>
                            
                                <li>
                <p>Project</p>
                <p> <Autocomplete className="inputcntlparent"
                  options={this.state.projectarrauto}
                  value={this.state.selectedProject}
                  onChange={this.onProjectChange}
                  getOptionLabel={(o) => o.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Search Project"
                      onChange={this.onloadProjectBind}
                    />
                  )}
                /></p>
              </li>

              <li>
                <p>Vendor</p>
                <p><Autocomplete className="inputcntlparent"
                  options={this.state.vendorarrauto}
                  value={this.state.selectedVendor}
                  onChange={this.onVendorChange}
                  getOptionLabel={(o) => o.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Search Vendor"
                      onChange={this.onloadVendorBind}
                    />
                  )}
                /></p>
              </li>

              <li>
                <p>&nbsp;</p>
                <Button variant="contained"         className="exportbtn" onClick={this.fetchReport}>
                  Search
                </Button> <Button
  variant="contained"
        className="exportbtn"
  onClick={() => this.setState({ openExportDialog: true })}
  sx={{ ml: 1 }}
>
  Export
</Button>
              </li>

            </ul>
          </div>

           <Paper >
          <TableContainer>
            <Table>

              <TableHead>
                <TableRow >
                  <TableCell >Project</TableCell>
                  <TableCell >Vendor</TableCell>
                  <TableCell >Amount</TableCell>
                  <TableCell >Paid</TableCell>
                  <TableCell >Due</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{r.Project}</TableCell>
                    <TableCell>{r.Vendor} - {r.service}</TableCell>

                    <TableCell>
					
					{r.val==="1" &&(
					 <NavLink
    to={`/MaterialPurchase-report?projectid=${r.ProjectId}&vmid=${r.VendorId}`}
    style={{
      display: "block",
     
      cursor: "pointer"
    }}
  >
                       Rs. {parseFloat(r.Amount || 0).toLocaleString("en-IN")}  </NavLink>
					)}
					
					{r.val==="2" &&(
					 <NavLink
    to={`/WagesReport?projectid=${r.ProjectId}`}
    style={{
      display: "block",
     
      cursor: "pointer"
    }}
  >
                       Rs. {parseFloat(r.Amount || 0).toLocaleString("en-IN")}  </NavLink>
					)}

{r.val==="3" &&(
					 <NavLink
    to={`/Expense-report?projectid=${r.ProjectId}&vmid=${r.VendorId}`}
    style={{
      display: "block",
     
      cursor: "pointer"
    }}
  >
                       Rs. {parseFloat(r.Amount || 0).toLocaleString("en-IN")}  </NavLink>
					)}						
					{r.val==="4" &&(
					 <NavLink
    to={`/ContractCostMap?projectid=${r.ProjectId}&vmid=${r.VendorId}`}
    style={{
      display: "block",
     
      cursor: "pointer"
    }}
  >
                       Rs. {parseFloat(r.Amount || 0).toLocaleString("en-IN")}  </NavLink>
					)}	
                    </TableCell>

                    <TableCell><NavLink
    to={`/PaymentOutReport?projectid=${r.ProjectId}&vmid=${r.VendorId}`}
    style={{
      display: "block",    
      cursor: "pointer"
    }}
  >
                       Rs. {parseFloat(r.Paid || 0).toLocaleString("en-IN")}	  </NavLink>
                    </TableCell>

                    <TableCell><NavLink
    to={`/VendorLedgerReport?&vendorid=${r.VendorId}`}
    style={{
      display: "block",
      cursor: "pointer"
    }}
  >
                      <b style={{ color: "red" }}>
                        Rs. {parseFloat(r.Due || 0).toLocaleString("en-IN")}
                      </b>  </NavLink>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

            </Table>

            {/*  PAGINATION  */}
            <TablePagination
			 rowsPerPageOptions={[50, 100, 150, 200, 250]} 
              component="div"
              count={this.state.totalRecords}
              page={this.state.page}
              rowsPerPage={this.state.rowsPerPage}
              onPageChange={this.handlePageChange}
              onRowsPerPageChange={this.handleRowsChange}
            />
<Dialog
  open={this.state.openExportDialog}
  onClose={() => this.setState({ openExportDialog: false })}
>
  <DialogTitle>Export Pending Payment Report</DialogTitle>

  <DialogContent>
    <div style={{ display: "flex", gap: 15, justifyContent: "center", marginTop: 10 }}>
      
      <Button
        variant="contained"
        onClick={this.exportExcel}
        sx={{ backgroundColor: "#2e7d32" }}
      >
        Excel
      </Button>

      <Button
        variant="contained"
        onClick={this.downloadPDF}
        sx={{ backgroundColor: "#d32f2f" }}
      >
        PDF
      </Button>

    </div>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => this.setState({ openExportDialog: false })}>
      Cancel
    </Button>
  </DialogActions>
</Dialog>
          </TableContainer>

        </Paper>
        </React.Fragment>
    );
  }
}

export default VendorProjectPendingPaymentReport;